export const AVATAR_INFO = 'Maximum file size is 1MB. Minimum dimension: 330x300 and Suitable files are .jpg & .png';
export const AVATAR_SIZE_ERROR = 'Maximum file size MUST be 1MB. Please try again.';
